
import React, { useState } from "react";
import MainLayouts from "../../Layout/MainLayouts";
// import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import axios from "axios";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as DashSquareFill } from "bootstrap-icons/icons/dash-square-fill.svg";
import { ReactComponent as FilePlusFill } from "bootstrap-icons/icons/file-plus-fill.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate, } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../api/AxiosApiCall";
import locationData from "../../components/utils/locationData.json"


const CreateDeliveryPrice = () => {

    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [amount, setAmount] = useState("");
    const [location, setLocation] = useState("");
    const [lcda, setLcda] = useState("");
    const [loading, setLoading] = useState(false);

    // Find selected state
    const selectedStateData = locationData.find(item => item.state === state);

    // Find selected city
    const selectedCityData = selectedStateData?.cities.find(item => item.name === city);

    // Build city and location lists
    const cities = selectedStateData ? selectedStateData.cities.map(c => c.name) : [];
    const locations = selectedCityData ? selectedCityData.locations : [];


    const navigate = useNavigate();

    // Validation function
    const validateForm = () => {
        if (!amount || !state || !city || !location) {
            toast.error("All fields are required.");
            return false;
        }
        return true;
    };


    //axios api encryption call
    const axios = AxiosApiCall();

    // handle submit button
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        const formData = {
            amount,
            state,
            city,
            location,
            lcda: location,
            lga: city
        };
        // console.log("this is my form data", formData);

        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) {
                throw new Error("No access token found.");
            }

            const response = await axios.post(
                ApiServices.createDeliveryLocprice,
                formData,

                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            const { status, message } = response.data;
            if (status === "200" || status === 200) {
                navigate("/admin/delivery/location");
                toast.success(message, { toastId: "location-price-created-success" });
                setAmount("");
                setCity("");
                setLocation("");
                setState("")
                // toast.success(message);
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    {/* form here */}
                    <section className=" body-font">
                        <div className="container px-5 pb-2 mx-auto ">
                            <section
                                className="w-full pr-[3%] pt-3 my-3"
                                style={{ backgroundColor: "#F7F7F7" }}
                            >
                                {/* Flex container for breadcrumb and back button */}
                                <div className="flex justify-between items-center bg-gray-200 py-2 px-4 rounded-lg mb-3">
                                    {/* Breadcrumb - Left aligned */}
                                    <nav>
                                        <ol className="list-none p-0 inline-flex">
                                            <li className="flex items-center">
                                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                                    Location Delivery
                                                </p>
                                                <ChevronRightIcon />
                                            </li>
                                            <li className="flex items-center">
                                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                                    Price
                                                </p>
                                                <ChevronRightIcon />
                                            </li>
                                            <li className="flex items-center">
                                                <p className="text-orange1">Create</p>
                                            </li>
                                        </ol>
                                    </nav>

                                    {/* <Link
                                        to="/operations/branch/list"
                                        className="text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                    >
                                        <span className="flex items-center">
                                            <ArrowLeftSquare className="mr-2" />
                                            Back To List
                                        </span>
                                    </Link> */}
                                </div>
                            </section>

                            <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                                <form onSubmit={handleSubmit}>

                                    {/* Phone Number and State */}
                                    <div className="flex flex-col md:flex-row w-full mb-3 gap-4">

                                        <div className="w-full md:w-1/2">
                                            <label htmlFor="state" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                State
                                            </label>
                                            <select
                                                name="state"
                                                id="state"
                                                value={state}
                                                onChange={(e) => {
                                                    setState(e.target.value);
                                                    setCity("");
                                                }}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                            >
                                                <option value="">Select state</option>
                                                {locationData.map((item) => (
                                                    <option key={item.state} value={item.state}>
                                                        {item.state}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="w-full md:w-1/2">
                                            <label htmlFor="city" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                City
                                            </label>
                                            <select
                                                name="city"
                                                id="city"
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                                disabled={!state}
                                            >
                                                <option value="">Select city</option>
                                                {cities.map((cityName) => (
                                                    <option key={cityName} value={cityName}>
                                                        {cityName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* City and Address */}
                                    <div className="flex flex-col md:flex-row w-full mb-3 gap-4">

                                        <div className="w-full md:w-1/2">
                                            <label htmlFor="location" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Location
                                            </label>
                                            <select
                                                name="location"
                                                id="location"
                                                value={location}
                                                onChange={(e) => {
                                                    setLocation(e.target.value);
                                                    setLcda(e.target.value);
                                                }}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                                disabled={!city}
                                            >
                                                <option value="">Select Location</option>
                                                {locations.map((loc) => (
                                                    <option key={loc} value={loc}>
                                                        {loc}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="w-full md:w-1/2">
                                            <label htmlFor="amount" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Amount
                                            </label>
                                            <input
                                                type="number"
                                                name="amount"
                                                id="amount"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                                placeholder="Enter amount"
                                            />
                                        </div>
                                    </div>

                                    {/* Buttons */}
                                    <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">

                                        <Link
                                            to="/admin/delivery/location"
                                            className="text-dGrey3 bg-black2 py-4 px-6 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm text-center"
                                        >
                                            <span className="flex items-center">
                                                <List className="mr-2" />
                                                Back To List
                                            </span>
                                        </Link>

                                        <button
                                            type="submit"
                                            className={`text-dGrey3 bg-darkGreen3 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium ${loading ? "btn-loading" : "btn-primary"}`}
                                            disabled={loading || !amount || !location || !state || !city}
                                        >
                                            {loading ? "Creating..." : "Create Delivery Price"}
                                        </button>

                                    </div>
                                </form>


                            </div>
                        </div>
                    </section>
                </div>
            </MainLayouts>
        </div>
    );
}

export default CreateDeliveryPrice;

